var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import QueryUtil from '../utils/QueryUtil';
import { getAppVersion, getDevice, getManufacturer, getModel, getOsVersion, } from '../utils/UAUtil';
import { getCookie, setCookie } from '../utils/CookieUtil';
var Header = /** @class */ (function () {
    function Header(config) {
        this.config = config;
        this.deviceId = this.getDeviceId();
        this.appVersion = this.getAppVersion();
        this.osVersion = getOsVersion();
        this.manufacturer = getManufacturer();
        this.model = getModel();
        this.device = getDevice();
        this.staticData = this.getStaticData();
    }
    Header.prototype.setUserId = function (userId) {
        this.config.userId = userId;
    };
    Header.prototype.getData = function () {
        return __assign({}, this.staticData, { userId: this.config.userId || 0 }, (this.config.extensions && {
            extensions: this.config.extensions,
        }));
    };
    Header.prototype.getDeviceId = function () {
        if (this.config.deviceId) {
            return this.config.deviceId;
        }
        var query = QueryUtil.search() || {};
        var deviceId = query._deviceId;
        if (!deviceId) {
            deviceId = getCookie('deviceId');
            if (!deviceId) {
                deviceId = new Date().getTime() + '-' + Math.random().toString().substr(-5);
                setCookie('deviceId', deviceId, 365);
                this.config.deviceId = deviceId;
            }
        }
        else {
            setCookie('deviceId', deviceId, 365);
            this.config.deviceId = deviceId;
        }
        return deviceId;
    };
    Header.prototype.getAppVersion = function () {
        return this.config.appVersion || getAppVersion() || '1.0.0';
    };
    Header.prototype.getStaticData = function () {
        var _a = this, osVersion = _a.osVersion, manufacturer = _a.manufacturer, model = _a.model;
        return __assign({ userId: this.config.userId || 0, device: this.device, deviceId: this.deviceId, appVersion: this.appVersion, screenWidth: window.screen.width, screenHeight: window.screen.height }, (this.config.extensions && {
            extensions: this.config.extensions,
        }), (osVersion && {
            osVersion: osVersion,
        }), (manufacturer && {
            manufacturer: manufacturer,
        }), (model && {
            model: model,
        }));
    };
    return Header;
}());
export default Header;
